import React, { FC, FormEvent } from 'react';
import { useDraftLoadContext } from '../../hooks/draft-load-context';
import { Load } from '../../../../types';
import { Row } from '@tanstack/react-table';
import { LoadTableRow } from './load-table-row';
import { LoadTableStops } from '../stops/load-table-stops';
import { useEditLoadMutation } from '../../../../api/mutations/reworked/edit/use-edit-load-mutation';
import { useDraftsLoadsContext } from '../../drafts-loads-context';

interface EditableLoadTableRowProps {
    isRowExpanded: boolean;
    row: Row<Load>;
}

export const EditableLoadTableRow: FC<EditableLoadTableRowProps> = (props) => {
    const { isRowExpanded, row } = props;
    const { isDrafts } = useDraftsLoadsContext();
    const { editedLoad } = useDraftLoadContext();
    const { mutate: editLoad } = useEditLoadMutation(isDrafts);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        editLoad({ load: editedLoad });
    };

    return (
        <form onSubmit={handleSubmit}>
            <LoadTableRow row={row} />
            {isRowExpanded && (
                <LoadTableStops
                    showInlineSaveButton={true}
                />
            )}
        </form>
    );
};
